<template>
  <div>
    <b-card>
      <h2>Relatório de Parcelas</h2>
      <validation-observer ref="formPesquisar">
        <b-form>
          <b-row>
            <b-col md="2">
              <b-form-group label="Pesquisar Por:" label-for="searchBy">
                <b-form-select id="searchBy" v-model="search.searchBy" :options="optionsSearchBy" />
              </b-form-group>
            </b-col>

            <b-col md="4">
              <b-form-group label="Descrição" label-for="searchValue">
                <b-form-input
                  id="searchValue"
                  :placeholder="search.searchBy == 1 ? 'Nome' : 'Nº Contrato'"
                  v-model="search.searchValue"
                />
              </b-form-group>
            </b-col>

            <b-col md="3">
              <b-form-group label="Unidade Gestora" label-for="institute">
                <v-select
                  id="institute"
                  v-model="search.institute"
                  :options="optionsInstitute"
                  :reduce="(option) => option.value"
                  label="text"
                  :multiple="true"
                  @input="handleSelectionInstitute"
                />
              </b-form-group>
            </b-col>

            <b-col md="3">
              <b-form-group label="Status do Contrato" label-for="status">
                <v-select
                  id="status"
                  :options="optionsStatus"
                  v-model="search.status"
                  :reduce="(option) => option.value"
                  label="text"
                  :multiple="true"
                  @input="handleSelectionStatusContrato"
                ></v-select>
              </b-form-group>
            </b-col>

            <b-col md="2">
              <b-form-group label="Data Inicial" label-for="dataInicial">
                <validation-provider #default="{ errors }" name="Data Inicial">
                  <b-input-group>
                    <cleave
                      id="dataInicial"
                      type="text"
                      placeholder="DD/MM/AAAA"
                      v-model="search.startDate"
                      class="form-control cleave-height"
                      :options="cleave.date"
                      :raw="false"
                    />
                    <b-input-group-append>
                      <b-form-datepicker
                        size="sm"
                        button-variant="primary"
                        class="datePickerWithInput"
                        right
                        button-only
                        v-model="startDatePicker"
                        :hide-header="true"
                        :initial-date="new Date()"
                        :state="errors[0] ? false : null"
                        label-help=""
                        label-calendar="Calendário"
                        label-close-button="Fechar"
                        label-current-month="Mês atual"
                        label-next-decade="Próxima década"
                        label-next-month="Próximo mês"
                        label-next-year="Próximo ano"
                        label-prev-decade="Década anterior"
                        label-prev-month="Mês anterior"
                        label-prev-year="Ano anterior"
                        label-select-month="Selecione o mês"
                        label-select-year="Selecione o ano"
                        label-selected="Selecionado"
                        label-no-date-selected="Nenhuma data selecionada"
                        label-reset-button="Resetar"
                        label-today-button="Hoje"
                        label-today="Hoje"
                        locale="pt-br"
                        :date-format-options="{ year: 'numeric', month: '2-digit', day: 'numeric' }"
                        aria-controls="dataInicial"
                      />
                    </b-input-group-append>
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="2">
              <b-form-group label="Data Final" label-for="dataFinal">
                <validation-provider
                  #default="{ errors }"
                  name="Data Final"
                  :rules="{
                    dataPassada: {
                      value: search.dataFinal,
                      dataParametro: search.dataInicial,
                      stringParametro: 'data inicial',
                    },
                  }"
                >
                  <b-input-group>
                    <cleave
                      id="dataFinal"
                      class="form-control"
                      type="text"
                      placeholder="DD/MM/AAAA"
                      v-model="search.endDate"
                      :options="cleave.date"
                      :raw="false"
                    />
                    <b-input-group-append>
                      <b-form-datepicker
                        size="sm"
                        button-variant="primary"
                        class="datePickerWithInput"
                        right
                        button-only
                        v-model="endDatePicker"
                        :hide-header="true"
                        :initial-date="new Date()"
                        :state="errors[0] ? false : null"
                        label-help=""
                        label-calendar="Calendário"
                        label-close-button="Fechar"
                        label-current-month="Mês atual"
                        label-next-decade="Próxima década"
                        label-next-month="Próximo mês"
                        label-next-year="Próximo ano"
                        label-prev-decade="Década anterior"
                        label-prev-month="Mês anterior"
                        label-prev-year="Ano anterior"
                        label-select-month="Selecione o mês"
                        label-select-year="Selecione o ano"
                        label-selected="Selecionado"
                        label-no-date-selected="Nenhuma data selecionada"
                        label-reset-button="Resetar"
                        label-today-button="Hoje"
                        label-today="Hoje"
                        locale="pt-br"
                        :date-format-options="{ year: 'numeric', month: '2-digit', day: 'numeric' }"
                        aria-controls="dataInicial"
                      />
                    </b-input-group-append>
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col class="d-flex justify-content-end">
              <b-col md="auto">
                <b-button
                  :disabled="isLoading"
                  variant="primary"
                  style="margin-top: 20px; width: 160px"
                  @click="handleSearch()"
                >
                  <b-spinner small v-if="isLoading" />
                  {{ !isLoading ? 'Pesquisar' : '' }}
                </b-button>
              </b-col>

              <b-col md="auto">
                <template>
                  <b-dropdown variant="link" no-caret toggle-class="p-0" left :popper-opts="{ positionFixed: true }">
                    <template #button-content>
                      <b-button variant="primary" style="margin-top: 20px; width: 160px"> Exportar </b-button>
                    </template>
                    <b-dropdown-item href="#" @click="handleExport('pdf')">
                      <feather-icon icon="FileTextIcon" size="16" />
                      <span class="align-middle ml-50" title="Exportar para PDF">PDF</span>
                    </b-dropdown-item>
                    <b-dropdown-item href="#" @click="handleExport('excel')">
                      <feather-icon icon="CheckCircleIcon" size="16" />
                      <span class="align-middle ml-50" title="Exportar para excel">Excel</span>
                    </b-dropdown-item>
                  </b-dropdown>
                </template>
              </b-col>
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
    </b-card>

    <b-card v-if="items.length > 0" class="mt-2">
      <b-table
        striped
        responsive
        foot-clone
        id="table_installment_report"
        class="position-relative"
        :items="items"
        :fields="fields"
        v-show="items.length > 0"
        :per-page="table.perPage"
        :current-page="table.currentPage"
        :sort-by.sync="table.sortBy"
        :sort-desc.sync="table.sortDesc"
        :sort-direction="table.sortDirection"
        :busy="isLoading"
      >
        <template v-slot:table-busy>
          <div class="text-center my-2">
            <b-spinner class="align-middle mr-1"></b-spinner>
            <strong>Carregando...</strong>
          </div>
        </template>
        <template #cell(contract_status)="row">
          <b-badge pill :variant="formatStatus(row.item.contract_status)">
            {{ row.item.contract_status }}
          </b-badge>
        </template>

        <template #foot()>
          <span> {{ '' }} </span>
        </template>

        <template #foot(contract_number)>
          <span>Total: </span>
        </template>

        <template #foot(installment_value)>
          <span>{{ formatarValor(table_totals.installment) }} </span>
        </template>
      </b-table>
      <b-card-body v-if="items.length > 0" class="d-flex justify-content-between flex-wrap pt-0">
        <b-form-group
          style="align-items: center"
          label="Por Página"
          label-cols="6"
          label-align="left"
          label-size="sm"
          label-for="sortBySelect"
          class="text-nowrap mb-md-0 mr-1"
        >
          <b-form-select id="perPageSelect" v-model="table.perPage" size="sm" inline :options="table.pageOptions" />
        </b-form-group>

        <b-pagination
          v-model="table.currentPage"
          :total-rows="items.length"
          :per-page="table.perPage"
          first-number
          last-number
          prev-class="prev-item"
          next-class="next-item"
          class="mb-0"
        >
          <template #prev-text>
            <feather-icon icon="ChevronLeftIcon" size="18" />
          </template>
          <template #next-text>
            <feather-icon icon="ChevronRightIcon" size="18" />
          </template>
        </b-pagination>
      </b-card-body>
    </b-card>

    <div>
      <RelatorioParcelaPaisagem ref="export" :params="params" />
    </div>
  </div>
</template>
<script>
  import useJwt from '@/auth/jwt/useJwt'
  import vSelect from 'vue-select'
  import Cleave from 'vue-cleave-component'
  import RelatorioParcelaPaisagem from './RelatorioParcelaPaisagem.vue'

  import { ValidationProvider, ValidationObserver } from 'vee-validate'
  import { formatarData, formatarValor } from '@/libs/utils'
  import { formatStatus } from '@/utils/formats/formatStatus'
  import { asDefault } from './exportExcel'
  import { generateAndDownloadPdf } from '@/utils/geradorPDF/geradorPDF'
  export default {
    components: {
      ValidationProvider,
      ValidationObserver,
      RelatorioParcelaPaisagem,
      vSelect,
      Cleave,
    },

    data() {
      return {
        formatStatus,
        formatarValor,
        isLoading: false,
        startDatePicker: '',
        endDatePicker: '',

        cleave: {
          date: {
            date: true,
            delimiter: '/',
            datePattern: ['d', 'm', 'Y'],
          },
        },
        params: {
          items: [],
          fields: [],
        },

        optionsSearchBy: [
          { value: 1, text: 'Nome' },
          { value: 2, text: 'Nº Contrato' },
        ],
        optionsInstitute: [{ value: 0, text: 'Todas' }],
        optionsStatus: [
          { value: 0, text: 'Todos' },
          { value: 'Pendente', text: 'Pendente' },
          { value: 'Consolidado', text: 'Consolidado' },
          { value: 'Quitado', text: 'Quitado' },
          { value: 'Cancelado', text: 'Cancelado' },
          { value: 'Segurado Exonerado', text: 'Segurado Exonerado' },
          { value: 'Segurado Falecido', text: 'Segurado Falecido' },
        ],

        table: {
          perPage: 10,
          currentPage: 1,
          pageOptions: [10, 50, 100],
          sortBy: '',
          sortDesc: false,
          sortDirection: 'asc',
        },

        table_totals: {
          installment: 0,
        },

        search: {
          searchBy: 1,
          searchValue: '',
          status: [0],
          institute: [0],
          startDate: '',
          endDate: '',
        },

        previousSelectionStatus: [0],
        previousSelectionInstitute: [0],

        items: [],
        fields: [
          {
            key: 'contract_number',
            label: 'N° Contrato',
            footer: '',
          },
          {
            key: 'name',
            label: 'Nome Tomador',
            sortable: true,
          },
          {
            key: 'installment_number',
            label: 'Parcela',
          },
          {
            key: 'contract_create_date',
            label: 'Data de Criação',
            sortable: true,
            formatter: (value) => formatarData(value),
          },
          {
            key: 'contract_value',
            label: 'Valor do Contrato',
            sortable: true,
            formatter: (value) => formatarValor(value),
          },
          {
            key: 'installment_value',
            label: 'Valor da Parcela',
            sortable: true,
            formatter: (value) => formatarValor(value),
          },
          {
            key: 'installment_maturity_date',
            label: 'Vencimento da Parcela',
            sortable: true,
            formatter: (value) => formatarData(value),
          },
          {
            key: 'contract_status',
            label: 'Status do Contrato',
            sortable: true,
          },
          {
            key: 'contract_institute',
            label: 'Unidade Gestora',
            sortable: true,
          },
        ],
        fieldsPdf: [
          {
            key: 'contract_number',
            label: 'N° Contrato',
            footer: '',
          },
          {
            key: 'name',
            label: 'Nome Tomador',
          },
          {
            key: 'installment_number',
            label: 'Parcela',
          },
          {
            key: 'contract_create_date',
            label: 'Data de Criação',

            formatter: (value) => formatarData(value),
          },
          {
            key: 'contract_value',
            label: 'Valor do Contrato',

            formatter: (value) => formatarValor(value),
          },
          {
            key: 'installment_value',
            label: 'Valor da Parcela',

            formatter: (value) => formatarValor(value),
          },
          {
            key: 'installment_maturity_date',
            label: 'Vencimento da Parcela',

            formatter: (value) => formatarData(value),
          },
          {
            key: 'contract_status',
            label: 'Status do Contrato',
          },
          {
            key: 'contract_institute',
            label: 'Unidade Gestora',
          },
        ],
      }
    },

    mounted() {
      this.handleLoadUnidadeGestora()
    },

    methods: {
      handleSelectionStatusContrato(selected) {
        const added = selected.filter((value) => !this.previousSelectionStatus.includes(value))

        if (added.includes(0)) {
          this.search.status = [0]
        } else if (added.length > 0) {
          this.search.status = selected.filter((value) => value !== 0)
        }

        this.previousSelectionStatus = [...this.search.status]
      },

      handleSelectionInstitute(selected) {
        const added = selected.filter((value) => !this.previousSelectionInstitute.includes(value))

        if (added.includes(0)) {
          this.search.institute = [0]
        } else if (added.length > 0) {
          this.search.institute = selected.filter((value) => value !== 0)
        }

        this.previousSelectionInstitute = [...this.search.institute]
      },

      handleLoadUnidadeGestora() {
        useJwt
          .get('cadastro/instituto')
          .then((response) => {
            this.optionsInstitute = { value: 0, text: 'Todas' }
            const listaInstituto = response.data.map((item) => {
              return { value: item.id, text: String(item.nome) }
            })
            this.optionsInstitute = [this.optionsInstitute, ...listaInstituto]
          })
          .catch((error) => {
            console.error(error)
          })
      },

      async handleSearch() {
        this.isLoading = true
        try {
          const response = await useJwt.post('relatorio/contract/installment/batch', this.search)

          this.table_totals.installment = response.data.map((item) => Number(item.installment_value)).reduce((a, b) => a + b, 0)
          this.items = response.data
        } catch {
          this.$message.error('Houve um erro ao carregar os dados')
        } finally {
          this.isLoading = false
        }
      },

      handleExport(type) {
        if (this.items.length == 0) {
          this.$message.error('Nenhum dado para exportar')
          return
        }

        const self = this
        if (type === 'pdf') {
          this.params = {
            items: this.items,
            fields: this.fieldsPdf,
            installment_total: this.table_totals.installment,
          }

          setTimeout(function () {
            self.handlePdf()
          }, 1000)
        } else if (type == 'excel') {
          this.handleExcel()
        }
      },

      handlePdf() {
        const htmlContent = this.$refs.export.$children[0].$refs.html2PdfLandscape.$el.innerHTML

        const reportName = `<div>Relatório de Parcelas</div>`
        const landscape = true
        generateAndDownloadPdf(this, htmlContent, null, reportName, landscape)
      },

      handleExcel() {
        try {
          this.$message.warning('Aguarde, estamos gerando o relatório')
          asDefault().export(this.items)
        } catch (error) {
          this.$message.error('Ocorreu um erro ao gerar o relatório', 'error')
          console.error(error)
        }
      },
    },

    watch: {
      startDatePicker(newVal) {
        this.search.startDate = formatarData(this.startDatePicker)
      },
      'search.startDate'(newVal) {
        if (!newVal) {
          this.startDatePicker = null
        }
      },
      endDatePicker(newVal) {
        this.search.endDate = formatarData(this.endDatePicker)
      },
    },
  }
</script>
<style lang=""></style>
